<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<template>
  <a class="flex !w-full items-center justify-between border-b-[0.5px] border-[#e2e2e2] py-3 !no-underline" href="#">
    <span class="block grow text-sm font-medium tracking-[-0.01em] text-main-dark">
      {{ title }}
    </span>

    <SvgIcon class="!size-6" name="outlined/arrow-next" />
  </a>
</template>
